import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const createSession = (customer, pathway, intake) =>
  api.post("/sessions", { customer, pathway, intake }).then((r) => r.data);

export const getSession = (sessionId) =>
  api.get(`/sessions/${sessionId}`).then((r) => r.data);

export const uploadPhoto = (sessionId, file, isPrimary = false, category = null) => {
  const form = new FormData();
  form.append("file", file);
  form.append("is_primary", isPrimary ? "true" : "false");
  if (category) form.append("category", category);
  return axios
    .post(`${API_BASE}/sessions/${sessionId}/photos`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const labelPhoto = (sessionId, photoId, category) =>
  api.patch(`/sessions/${sessionId}/photos/${photoId}`, { category }).then((r) => r.data);

export const setPortfolioConsent = (sessionId, granted) =>
  api.post(`/sessions/${sessionId}/portfolio-consent`, { granted }).then((r) => r.data);

export const startVerdant = (sessionId) =>
  api.post(`/sessions/${sessionId}/verdant-start`, { acknowledged: true }).then((r) => r.data);

export const deletePhoto = (sessionId, photoId) =>
  api.delete(`/sessions/${sessionId}/photos/${photoId}`).then((r) => r.data);

export const requestConsultation = (sessionId, notes, manualReview = false) =>
  api
    .post(`/sessions/${sessionId}/consultation`, { session_id: sessionId, notes, manual_review: manualReview })
    .then((r) => r.data);

export const startAssessment = (sessionId) =>
  api.post(`/sessions/${sessionId}/assessment`).then((r) => r.data);

export const photoUrl = (photoId) => `${API_BASE}/photos/${photoId}`;
export const conceptUrl = (conceptId) => `${API_BASE}/concepts/${conceptId}`;

let configPromise;
export const getConfig = () => {
  if (!configPromise) {
    configPromise = api.get("/config").then((r) => r.data).catch(() => ({ phase3_enabled: false }));
  }
  return configPromise;
};

export const updateIntake = (sessionId, intake) =>
  api.patch(`/sessions/${sessionId}/intake`, { intake }).then((r) => r.data);

export const generateConcept = (sessionId) =>
  api.post(`/sessions/${sessionId}/concept`, { confirmed: true }).then((r) => r.data);

export const acknowledgeDisclaimer = (sessionId) =>
  api.post(`/sessions/${sessionId}/disclaimer`).then((r) => r.data);

export const requestRevision = (sessionId, adjustment, comment) =>
  api.post(`/sessions/${sessionId}/revision`, { adjustment, comment }).then((r) => r.data);

export const getConcepts = (sessionId) => api.get(`/sessions/${sessionId}/concepts`).then((r) => r.data);

export const createCheckout = (payload) =>
  api.post("/payments/checkout", { ...payload, origin_url: window.location.origin }).then((r) => r.data);

export const getPaymentStatus = (stripeSessionId) =>
  api.get(`/payments/status/${stripeSessionId}`).then((r) => r.data);

export const retryConcept = (conceptId) => api.post(`/concepts/${conceptId}/retry`).then((r) => r.data);

export const getProject = (token) => api.get(`/projects/${token}`).then((r) => r.data);

export const makeAnswerCard = (sessionId, speaker, text, requestId) =>
  api.post("/answer-card", { session_id: sessionId, speaker, text, request_id: requestId }).then((r) => r.data);
export const startCardCheckout = (sessionId) =>
  api.post("/answer-card/checkout", { session_id: sessionId, origin_url: window.location.origin }).then((r) => r.data);
export const getCardCheckoutStatus = (id) => api.get(`/answer-card/checkout-status/${id}`).then((r) => r.data);
export const startTalk = (firstName, email) => api.post("/talk/start", { first_name: firstName, email }).then((r) => r.data);
export const logAnswerCard = (id, action) => api.post(`/answer-card/${id}/event`, { action }).catch(() => {});

export const saveConversation = (sessionId, caseId, messages) =>
  api.post(`/sessions/${sessionId}/conversation`, { case_id: caseId, messages }).then((r) => r.data);
export const getReportOffer = (sessionId) => api.get(`/sessions/${sessionId}/report-offer`).then((r) => r.data);
export const getConversationPrint = (sessionId) => api.get(`/sessions/${sessionId}/conversation-print`).then((r) => r.data);
export const createReportCheckout = (sessionId, pkg) =>
  api.post("/reports/checkout", { session_id: sessionId, package: pkg, origin_url: window.location.origin }).then((r) => r.data);
export const getReportCheckoutStatus = (id) => api.get(`/reports/checkout-status/${id}`).then((r) => r.data);
export const getReport = (id, t) => api.get(`/reports/${id}`, { params: { t } }).then((r) => r.data);
export const reportFileUrl = (id, t, kind, dl = false) =>
  `${API_BASE}/reports/${id}/${kind}?t=${encodeURIComponent(t)}${dl ? "&dl=1" : ""}`;
